import { render, staticRenderFns } from "./Knowledge-hub.vue?vue&type=template&id=108e239e&scoped=true&"
import script from "./Knowledge-hub.vue?vue&type=script&lang=js&"
export * from "./Knowledge-hub.vue?vue&type=script&lang=js&"
import style0 from "./Knowledge-hub.vue?vue&type=style&index=0&id=108e239e&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "108e239e",
  null
  
)

export default component.exports